// extracted by mini-css-extract-plugin
module.exports = {"shadow":"menu-item_shadow__2hXnK","textShadow":"menu-item_textShadow__1IEBa","menuItem":"menu-item_menuItem__2-8QD","active":"menu-item_active__qHZOG"};